import React from "react";
import { checkedData, links } from "../rawData/MenuData";

import { RiArrowRightSFill } from "react-icons/ri";
const LinkLists = () => {
  return (
    <>
      <div className="sideBox">
        <ul className="border-top ">
          <h6>{window.location.pathname}</h6>
          {links.map((val)=>
          <li>
            <RiArrowRightSFill />
            <a>{val.item}</a>
          </li>
          )}
          
        </ul>
      </div>
    </>
  );
};

export default LinkLists;
